// ----------------------------------------------------------------------------
// Template: Metaobject - Author
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'snippets/breadcrumbs/breadcrumbs';
import 'sections/header/header';
import 'sections/author-hero/author-hero';
import 'sections/author-articles/author-articles';
import 'sections/footer/footer';